module.exports = __webpack_public_path__ + "img/icon-xlsx.6dce8a48.svg";